import { render, staticRenderFns } from "./CommunityListView.vue?vue&type=template&id=6368d6a0"
import script from "./CommunityListView.vue?vue&type=script&lang=js"
export * from "./CommunityListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports